module.exports = { "default": require("core-js/library/fn/json/stringify"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// ../js/~/babel-runtime/core-js/json/stringify.js
// module id = 578
// module chunks = 0